import React from 'react';
import { Img } from 'react-image';
import styled, { ThemeContext } from 'styled-components';
import Plx from 'react-plx';
import { scroller } from 'react-scroll';
import {
  SectionName, buildPlxData, SmallButton,
} from '../common/styles';
import {
  BaseContainer, BaseDesc, BaseTitle,
} from './styles';

const Container = styled(BaseContainer)`
  margin-top: ${props => (props.theme.isMobile ? '32px' : '80px')};
  margin-bottom: ${props => (props.theme.isMobile ? '32px' : '80px')};
`;

const Image = styled(Img)`
  ${props => (props.theme.isMobile ? `
    width: 100%;
  ` : `
    max-width: 560px;
    width: 44vw;
  `)};
`;

const SectionNameExt = styled(SectionName)`
  color: ${props => props.theme.bodyColor};
  font-size: 16px;
`;

const BaseDescExt = styled(BaseDesc)`
  a {
    color: #1E58CF;
    text-decoration: underline;
  }
`;

const Button = styled(SmallButton)`
  background-color: #374662;
  margin-top: 8px;
  width: 254px;

  &:hover {
    background-color: #BDC8DB;
  }
`;

export default function LivewireNetwork() {
  const { livewireNetworkImage, isMobile } = React.useContext(ThemeContext);
  const plxData = buildPlxData('#livewire_network', 0);

  const scrollToGetInTouchForm = () => scroller.scrollTo('get_in_touch', {
    duration: 1500,
    smooth: 'easeInOutQuint',
  });

  return (
    <Container id="livewire_network">
      <Plx className="left-section" parallaxData={plxData.text} disabled={isMobile}>
        <SectionNameExt>The Livewire network</SectionNameExt>
        <BaseTitle>Australia’s Leading Destination for Investors</BaseTitle>
        <BaseDescExt>
          Our brands&nbsp;
          <a href="https://www.livewiremarkets.com">Livewire Markets</a>
          &nbsp;and&nbsp;
          <a href="https://www.marketindex.com.au">Market Index</a>
          , empower one million investors every month by giving them
          free access to high quality investment information and analysis.
        </BaseDescExt>
        <Button onClick={scrollToGetInTouchForm}>Discover Our Audience - Connect Today</Button>
      </Plx>
      <Plx className="base-section" parallaxData={plxData.image} disabled={isMobile}>
        <Image src={livewireNetworkImage} />
      </Plx>
    </Container>
  );
}
